// utils/redux/inventoryTransaction/inventoryTransactionActions.js
import {
    setTransactions,
    addTransaction,
    updateTransaction,
    setLoading,
    setError,
    clearError
} from "./inventoryTransactionSlice";
import { getMethod, postMethod, putMethod } from "../../api-service/api-service";

// Create a single transaction
export const createTransactionAction = (data) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await postMethod('/inventory/transactions', data);
        if (response?.success) {
            dispatch(addTransaction(response.data.transaction));
        }
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Bulk adjustment (physical count)
export const bulkAdjustmentAction = (data) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await postMethod('/inventory/transactions/bulk-adjustment', data);
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Get transactions for a material
export const fetchMaterialTransactionsAction = (rawMaterialId, params = {}) => async (dispatch) => {
    try {
        dispatch(setLoading(true));

        const cleanParams = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== undefined && value !== null)
        );
        const query = new URLSearchParams(cleanParams).toString();

        const response = await getMethod(`/inventory/transactions/material/${rawMaterialId}?${query}`);

        if (response?.success) {
            dispatch(setTransactions(response));
        }

        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Get transaction by ID
export const fetchTransactionByIdAction = (transactionId) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await getMethod(`/inventory/transactions/${transactionId}`);
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Reverse a transaction
export const reverseTransactionAction = (transactionId, data) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await postMethod(`/inventory/transactions/${transactionId}/reverse`, data);
        if (response?.success) {
            dispatch(updateTransaction(response.data.original));
        }
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Bulk import transactions
export const bulkImportTransactionsAction = (data) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await postMethod('/inventory/transactions/bulk', data);
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// ==================== REPORT ACTIONS ====================

// Get valuation report
export const fetchValuationReportAction = (params = {}) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const query = new URLSearchParams(params).toString();
        const response = await getMethod(`/inventory/reports/valuation?${query}`);
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Get movement report
export const fetchMovementReportAction = (params = {}) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const cleanParams = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== undefined && value !== null)
        );
        const query = new URLSearchParams(cleanParams).toString();
        const response = await getMethod(`/inventory/reports/movement?${query}`);
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Get adjustment summary
export const fetchAdjustmentSummaryAction = (params = {}) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const query = new URLSearchParams(params).toString();
        const response = await getMethod(`/inventory/reports/adjustments?${query}`);
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Get dashboard stats
export const fetchDashboardStatsAction = () => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await getMethod('/inventory/dashboard/stats');
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Clear error
export const clearTransactionError = () => (dispatch) => {
    dispatch(clearError());
};